import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import AgeGate from "@/components/AgeGate";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Coa from "@/pages/Coa";
import { PrivacyPolicy, RefundPolicy, SalesPolicy, CompliancePolicy, TermsConditions } from "@/pages/Legal";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AgeGate />
          <div className="flex min-h-screen flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/coa" element={<Coa />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/sales-policy" element={<SalesPolicy />} />
                <Route path="/compliance-policy" element={<CompliancePolicy />} />
                <Route path="/terms" element={<TermsConditions />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={{
              style: {
                background: "#ffffff",
                border: "1px solid rgba(201,154,99,0.4)",
                color: "#2b2520",
              },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
